import React from 'react';
import { Helmet } from 'react-helmet-async';
import { NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import '../../styles/pages/Error.css';

var bnrimg = require('./../../images/banner/6.jpg');

class Error extends React.Component {
    render() {
        return (
            <>
                <Helmet>
                    <title>bs clads</title>
                </Helmet>
                <Header />
                <div className="page-content">
                    <Banner title="Page Not Found" pagename="404 Error" description="The page you are looking for might have been removed, had its name changed, or is temporarily unavailable." bgimage={bnrimg}/>
                    
                    <div className="section-full mobile-page-padding p-tb100 bg-white">
                        <div className="container">
                            <div className="section-content">
                                <div className="page-notfound row align-items-center justify-content-center text-center">
                                    <div className="col-md-8">
                                        <h1 style={{ fontSize: '96px', fontWeight: '800', color: '#c5a47e', marginBottom: '10px' }}>404</h1>
                                        <h3 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '15px' }}>Page Not Found</h3>
                                        <p style={{ fontSize: '16px', color: '#666', marginBottom: '30px' }}>The requested page could not be found. Return to our homepage to continue exploring our architectural solutions.</p>
                                        <NavLink to={"/"} title="Back to home" className="site-button btn-half"><span>Back To Home</span></NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </>
        );
    };
};

export default Error;